import { Expose, Transform, Type } from 'class-transformer'

import { Base } from './Base'
import { BarcodedUnit } from './BarcodedUnit'
import { FreightOrder } from './FreightOrder'

export class FreightOrderBarcodedUnit extends Base {
  @Expose({ name: 'unit' })
  @Transform(({ unit }) => unit?.guid)
  guid: string = ''

  @Type(() => FreightOrder)
  order?: FreightOrder

  @Type(() => BarcodedUnit)
  unit?: BarcodedUnit
}
